import React, { Component } from 'react';
import PropTypes from 'prop-types';

const { ADV } = window;

class AlightTermsView extends Component {
  constructor(props) {
    super(props);
    this.setFormRef = this.setFormRef.bind(this);
    this.state = {
      formSubmitted: false,
    };
  }

  componentDidMount() {
    const { portalName } = this.props;

    document.title = `Alight Terms and Conditions | ${portalName}`;
  }

  setFormRef(formRef) {
    this.formRef = formRef;
  }

  render() {
    const { name, agreementText, csrf, checked, onCheckboxToggle, onVideoToggle } = this.props;
    const { formSubmitted } = this.state;

    const currentLanguage = Localize.getLanguage();

    return (
      <div className="alight-terms-layout">
        <div className="alight-terms-layout-top">
          <div className="alight-terms-layout-top-left">
            <h3 className="alight-welcome-header">Welcome {name},</h3>
            <p className="alight-welcome-paragraph">{agreementText}</p>
            <form
              method="post"
              action="/Consumer/Alight"
              ref={this.setFormRef}
              onSubmit={event => {
                event.preventDefault();
                this.setState({
                  formSubmitted: true,
                });

                this.formRef.submit();
              }}
            >
              <input name="__RequestVerificationToken" type="hidden" value={csrf} />
              <label htmlFor="AlightCheckboxAccepted" className="alight-form-checkbox-label">
                <input
                  className="alight-form-input-checkbox"
                  type="checkbox"
                  id="AlightCheckboxAccepted"
                  checked={checked}
                  onChange={onCheckboxToggle}
                />
                <i className="alight-form-checkbox-mark" />I have read and I accept the&nbsp;
              </label>
              <a
                className="alight-form-link"
                rel="noopener noreferrer"
                target="_blank"
                href={`${ADV.settings.endpoints.assets}policies/Advizr_AFA_Terms_and_Conditions${
                  currentLanguage === 'fr-CA' ? '--fr-CA' : ''
                }.pdf`}
              >
                Terms and Conditions
              </a>
              <button
                className="alight-form-button"
                disabled={formSubmitted || !checked}
                type="submit"
              >
                Get Started
              </button>
            </form>
            <div className="alight-logo-svg">
              <img alt="alight logo" src={`${ADV.settings.endpoints.imgDir}alight-logo.svg`} />
            </div>
          </div>
          <div className="alight-terms-layout-top-right">
            <h3 className="alight-learn-more">Learn More</h3>
            <h4 className="alight-learn-more-subtitle">Watch our video</h4>
            <button
              className="alight-learn-more-video-button"
              onClick={onVideoToggle}
              type="button"
            >
              <i className="fas fa-play" />
            </button>
          </div>
        </div>
        <div className="alight-terms-layout-bottom">
          <div className="alight-terms-layout-bottom-copyright">Copyright © 2018 Alight Inc.</div>
          <ul className="alight-terms-layout-bottom-ul">
            <li className="alight-terms-layout-bottom-li">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href={`${ADV.settings.endpoints.assets}policies/Advizr_AFA_Terms_and_Conditions${
                  currentLanguage === 'fr-CA' ? '--fr-CA' : ''
                }.pdf`}
                className="alight-terms-layout-bottom-li-a"
              >
                Terms and conditions
              </a>
            </li>
            <li className="alight-terms-layout-bottom-li">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href={`${ADV.settings.endpoints.assets}policies/Alight_Legal_Notice${
                  currentLanguage === 'fr-CA' ? '--fr-CA' : ''
                }.pdf`}
                className="alight-terms-layout-bottom-li-a"
              >
                Other Legal Information
              </a>
            </li>
            <li className="alight-terms-layout-bottom-li">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href={`${ADV.settings.endpoints.assets}policies/Alight_Privacy_Statement${
                  currentLanguage === 'fr-CA' ? '--fr-CA' : ''
                }.pdf`}
                className="alight-terms-layout-bottom-li-a"
              >
                Afa privacy statement
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

AlightTermsView.propTypes = {
  name: PropTypes.string.isRequired,
  agreementText: PropTypes.string.isRequired,
  csrf: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onCheckboxToggle: PropTypes.func.isRequired,
  onVideoToggle: PropTypes.func.isRequired,
  portalName: PropTypes.string.isRequired,
};

export default AlightTermsView;
